import React from 'react';
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';

import {langService} from "../../../jwt/_services";
import LangTab from "../../../components/tabs/langTab";
import {showLoader} from "../../../components/loader/loader";
import {FL_INDICATIONS, FL_IVERTED_INDICATIONS, FL_TITLE} from "../../../components/i18n/formLabels";
import {PH_INDICATIONS, PH_INVERTED_INDICATIONS, PH_TITLE} from "../../../components/i18n/placeHolders";


class VectorInputLangs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: this.props.editMode,
            disableInputs : this.props.disableInputs,
            loading: false,

            vector : this.props.vector,
            langChilds: [],
            langVectorChilds: this.props.langs,
        }

        this.getLangChilds = this.getLangChilds.bind(this);
        this.getFormulary = this.getFormulary.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
    }

    async componentDidMount() {
        this.setState({ loading: true });
        // ----------------------------------
        // Establece las opciones de idioma
        // ----------------------------------
        let langChilds = [];

        langService.getAll()
            .then(langOptions => {
                if (langOptions){
                    langOptions.map((lang) => {
                        const langChild = {
                            lang: lang,
                            id: '',
                            
                            title: '',
                            indication: '',
                            invertedIndication: '',
                        };
                        langChilds.push(langChild);
                        this.setState({
                            langChilds,
                            loading: false
                        });
                    });
                }else {
                    this.setState({loading: false});
                }

            })
            .then( () => {
                // ----------------------------------
                // Consulta los idiomas guardados
                // ----------------------------------
                if (this.state.editMode){
                    langChilds = this.combineLangChilds(this.state.langChilds, this.state.langVectorChilds);
                }
            })
            .catch(() => {
                this.setState({
                    loading: false
                });
            });
    }

    getLangChilds(){
        const langChilds = this.combineLangChilds(this.state.langChilds, this.state.langVectorChilds);
        return (langChilds ? langChilds : (this.state?.langChilds ? this.state?.langChilds : []));
    }

    changeDisabledInput(option){
        this.setState({disableInputs : option });
        this.getLangChilds();
    }

    combineLangChilds(langOptions, langVectorChilds){
        try {
            if (langOptions && langVectorChilds && langOptions.length > 0 && langVectorChilds.length > 0){
                langOptions.map((child, index) => {
                    const langawardsIndex = langVectorChilds.findIndex(n => n.lang.id === child.lang.id);

                    if (langawardsIndex !== -1) {
                        langOptions[index] = {
                            lang :  langVectorChilds[langawardsIndex].lang,
                            id :    langVectorChilds[langawardsIndex].id,

                            title :  langVectorChilds[langawardsIndex].title,
                            indication :  langVectorChilds[langawardsIndex].indication,
                            invertedIndication :  langVectorChilds[langawardsIndex].invertedIndication,
                        }
                    }
                });

                return langOptions;
            }
        } catch (e) {
            return e.message;
        }
    }

    onInputChange (e, lang) {
        // Se busca el indice del idioma que se esta editando
        const langIndex = this.state.langVectorChilds.length > 0 ? this.state.langVectorChilds.findIndex(n => n.lang.id === lang.id) : this.state.langChilds.findIndex(n => n.lang.id === lang.id);

        if(langIndex === -1)
            return;
        // Se genera un nuevo arreglo para poder editar
        const langs = this.state.langVectorChilds.length > 0 ? this.state.langVectorChilds.slice() : this.state.langChilds.slice();

        langs[langIndex] = { ...langs[langIndex], [ e.target.name ]: e.target.value };
        this.props.setLangs(langs);
        this.setState({
            langChilds : langs,
            langVectorChilds : langs
        });
    }

    getFormulary(child, index, disableInputs){
        return (
            <Row>
                <Col md={'12'}>
                    <FormGroup>
                        <Label>{ FL_TITLE }</Label>
                        <Input
                            type={"text"}
                            name={"title"}
                            placeholder={ PH_TITLE }
                            autoFocus={true}
                            value= { child.title }
                            onChange={e => this.onInputChange(e, child.lang)}
                            disabled={disableInputs}
                        />
                    </FormGroup>
                </Col>
                <Col md={'12'}>
                    <FormGroup>
                        <Label>{ FL_INDICATIONS }</Label>
                        <Input
                            type={"textarea"}
                            rows={"8"}
                            name={"indication"}
                            placeholder={ PH_INDICATIONS }
                            value={ child.indication }
                            onChange={e => this.onInputChange(e, child.lang)}
                            disabled={disableInputs}
                        />
                    </FormGroup>
                </Col>
                <Col md={'12'}>
                    <FormGroup>
                        <Label>{ FL_IVERTED_INDICATIONS }</Label>
                        <Input
                            type={"textarea"}
                            rows={"8"}
                            name={"invertedIndication"}
                            placeholder={ PH_INVERTED_INDICATIONS }
                            value={ child.invertedIndication }
                            onChange={e => this.onInputChange(e, child.lang)}
                            disabled={disableInputs}
                        />
                    </FormGroup>
                </Col>
            </Row>
        );
    }

    render() {

        return (
            <div>
                {this.state.loading ? showLoader() : null}
                <Row>
                    <Col md="12">
                        <LangTab
                            key={"LangTabId"}
                            langChilds={this.state.langChilds}
                            getLangChilds={this.getLangChilds}
                            getFormulary={this.getFormulary}
                            getDisableInputs={this.getDisableInputs}
                            disableInputs={this.state.disableInputs}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default VectorInputLangs;
